<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Editor from '@/components/Editor/main.vue';
import LoadingIcon from '@/components/Loading/main.vue';
import Swal from 'sweetalert2';
import Footer from '@/components/Footer/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';

import { campaignMethods, masterMethods } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';
import { LIST_APPLICATION_CLOUD, configOption, convertNtoBr } from './constants';

export default {
    page: {
        title: '当選配信文言テンプレート作成',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        LoadingIcon,
        Editor,
        Layout,
        Footer,
        Multiselect
    },
    data() {
        return {
            obj: null,
            checkSecond: false,
            shortCode: [
                '《キャンペーン名》',
                '《キャンペーン開始》',
                '《キャンペーン事務局連絡先》',
                '《事務局開始》',
                '《事務局終了》',
                '《年末年始休み》'
            ],
            isLoading: false,
            template: {},
            templateDetail: {},
            listDataMasterTemplate: [],
            configSelectTemplate: configOption.configSelectTemplate,
            configEditor: configOption.configEditor,
            loadingEditor: false,
            listAppCloud: LIST_APPLICATION_CLOUD()
        };
    },
    mounted() {
        this.getListMasterTemplate();
        setTimeout(() => {
            const editorIframe = document.querySelector('.tox-edit-area iframe');
            if (editorIframe) {
                editorIframe.contentDocument.querySelector('p').style.margin = '0';
            }
        });
    },
    methods: {
        checkPermission,
        ...masterMethods,
        ...campaignMethods,
        convertNtoBr,

        onEditorInit(editor) {
            this.obj = editor;
        },

        getListMasterTemplate() {
            this.templateList().then((data) => {
                if (data.code == 200) {
                    this.listDataMasterTemplate = data.data;
                }
            });
        },
        onHandleInsertShort(data) {
            this.obj.insertContent(data);
        },
        checkPermiss(listRole) {
            return checkPermission(listRole);
        },
        getDraf() {
            if (this.template && !this.template.id) {
                this.resetTemplate();
            } else {
                this.loadingEditor = true;
                this.templateGetDraf(this.template).then((data) => {
                    if (data.code == 200) {
                        if (data.data && data.data.template_id) {
                            this.templateDetail = data.data;
                            this.templateDetail.id = this.templateDetail.template_id;
                            this.loadingEditor = false;
                        } else {
                            this.getDetail(false);
                        }
                    }
                });
            }
        },
        getDetail(check) {
            this.loadingEditor = true;
            this.templateGetDetail(this.template).then((data) => {
                if (data.code == 200) {
                    this.templateDetail = data.data;
                    this.loadingEditor = false;

                    if (check) {
                        showMessage(data.code, this.$bvToast, '前の状態に戻りました。');
                    }
                }
            });
        },
        removeDraft() {
            this.removeDraf(this.templateDetail).then(() => {});
        },
        rollback() {
            this.getDetail(true);
        },
        deleteTemplate() {
            Swal.fire({
                title: '削除してもよろしいですか。',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#5664d2',
                cancelButtonColor: '#EFF2F7',
                confirmButtonText: 'OK',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                if (result.value) {
                    this.templateDelete(this.templateDetail).then((data) => {
                        if (data.code == 200) {
                            showMessage(data.code, this.$bvToast, '削除されました');
                            this.resetTemplate();
                            this.getListMasterTemplate();
                        } else {
                            showMessage(data.code, this.$bvToast, this.$t(data.message));
                        }
                    });
                }
            });
        },
        resetTemplate() {
            this.template = {
                id: '',
                name: ''
            };
            this.templateDetail = {};
            this.obj.setContent('');
        },
        save(type) {
            const copyTem = { ...this.templateDetail };
            if (type == 1) {
                this.isLoading = true;
                this.saveDraf(copyTem).then((data) => {
                    if (data.code == 200) {
                        showMessage(data.code, this.$bvToast, '上書きとして保存されています。');
                    }
                    this.isLoading = false;
                });
            }
            if (type == 2) {
                this.isLoading = true;
                this.templateUpdate(copyTem).then((data) => {
                    if (data.code == 200) {
                        this.removeDraft();
                        showMessage(data.code, this.$bvToast, '保存されています。');
                        this.getListMasterTemplate();
                        this.getDetail(false);
                    }
                    this.isLoading = false;
                });
            }
            if (type == 3) {
                if (!copyTem.name) {
                    this.checkSecond = true;
                    return;
                }
                copyTem.content = `<div style="font-family: 'Meiryo', 'MS PGothic', 'Hiragino Kaku Gothic ProN', sans-serif; font-size: 10pt">${copyTem.content}</div>`;
                let payload = { is_create: true, ...copyTem };
                this.isLoading = true;
                this.templateCreate(payload).then((data) => {
                    if (data.code == 200) {
                        showMessage(data.code, this.$bvToast, '別名で保存されています。');
                        this.$bvModal.hide('modal-othername');
                        this.getListMasterTemplate();
                        this.resetTemplate();
                    } else {
                        showMessage(data.code, this.$bvToast, this.$t('template.' + data.message));
                    }
                    this.isLoading = false;
                });
            }
        }
    }
};
</script>

<template>
    <Layout>
        <div v-if="!isLoading" class="row form__common--center">
            <div class="col-lg-12">
                <div class="card form--sroll1 mb-0">
                    <div class="card-body">
                        <div>
                            <div class="form-group row">
                                <label class="pr-0" style="min-width: 100px">{{ $t('screenMaster.template.templateSelection') }}</label>
                                <div class="col-sm-6 p-0" style="max-width: 735px">
                                    <Multiselect
                                        :id="`select-template`"
                                        :value.sync="template"
                                        :options="listDataMasterTemplate"
                                        :config.sync="configSelectTemplate"
                                        @select="getDraf()"
                                        @remove="resetTemplate()"
                                    />
                                </div>
                            </div>

                            <div class="form-group row">
                                <label class="pr-0" style="min-width: 100px">{{ $t('screenMaster.template.content') }}</label>
                                <div class="col-sm-11">
                                    <div class="row">
                                        <div class="col-sm-6 p-0">
                                            <Editor
                                                :model.sync="templateDetail.content"
                                                :modelEvents="`change keydown blur focus paste`"
                                                :configInit="configEditor"
                                                :isLoading="loadingEditor"
                                                @init="onEditorInit"
                                            />
                                        </div>
                                        <div class="col-sm-6 pr-0" style="height: 600px; overflow-y: auto">
                                            <div class="accordion__template--condition table-responsive">
                                                <table class="table table-bordered table-box">
                                                    <thead>
                                                        <th>{{ $t('screenMaster.template.stt') }}</th>
                                                        <th>{{ $t('screenMaster.template.nameShort') }}</th>
                                                        <th>{{ $t('screenMaster.template.description') }}</th>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(itemList, idx) in listAppCloud">
                                                            <template v-if="['0'].includes(itemList.id)">
                                                                <tr v-for="(itemData, k) in itemList.data" :key="`${k}-${idx}`">
                                                                    <td class="colOne">
                                                                        {{ itemData.id }}
                                                                    </td>
                                                                    <td class="colTwo">
                                                                        <template v-if="Array.isArray(itemData.name_short)">
                                                                            <template v-for="(itemName, idxName) in itemData.name_short">
                                                                                <div
                                                                                    v-b-tooltip.hover
                                                                                    :title="itemName"
                                                                                    :key="`shortName-${idxName}`"
                                                                                    class="text-left mb-2"
                                                                                    style="cursor: pointer"
                                                                                    @click="onHandleInsertShort(itemName)"
                                                                                >
                                                                                    {{ itemName }}
                                                                                </div>
                                                                            </template>
                                                                        </template>
                                                                        <template v-else>
                                                                            <div
                                                                                v-b-tooltip.hover
                                                                                :title="itemData.name_short"
                                                                                class="text-left mb-2"
                                                                                style="cursor: pointer"
                                                                                @click="onHandleInsertShort(itemData.name_short)"
                                                                            >
                                                                                {{ itemData.name_short }}
                                                                            </div>
                                                                        </template>
                                                                    </td>
                                                                    <td class="text-left colThree">
                                                                        <div
                                                                            class="row-data-large text-wrap"
                                                                            v-b-tooltip.hover
                                                                            :title="itemData.description"
                                                                        >
                                                                            {{ itemData.description }}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-else>
                                                                <tr :key="`${idx}`">
                                                                    <td :colspan="3" class="p-0">
                                                                        <b-button
                                                                            class="my-2 text-left p-1"
                                                                            block
                                                                            v-b-toggle="'accordion-' + `${idx}`"
                                                                            variant="light"
                                                                            style="max-width: 260px"
                                                                        >
                                                                            {{ itemList.title }}
                                                                        </b-button>
                                                                        <b-collapse
                                                                            :id="'accordion-' + `${idx}`"
                                                                            accordion="my-accordion"
                                                                            role="tabpanel"
                                                                        >
                                                                            <table class="table table-bordered table__collapse--template table-box">
                                                                                <tr v-for="(itemData, k) in itemList.data" :key="`${k}-${idx}`">
                                                                                    <td class="colOne">
                                                                                        {{ itemData.id }}
                                                                                    </td>
                                                                                    <td class="colTwo">
                                                                                        <template v-if="Array.isArray(itemData.name_short)">
                                                                                            <template
                                                                                                v-for="(itemName, idxName) in itemData.name_short"
                                                                                            >
                                                                                                <div
                                                                                                    v-b-tooltip.hover
                                                                                                    :title="itemName"
                                                                                                    :key="`shortName-${idxName}`"
                                                                                                    class="text-left mb-2"
                                                                                                    style="cursor: pointer"
                                                                                                    @click="onHandleInsertShort(itemName)"
                                                                                                >
                                                                                                    {{ itemName }}
                                                                                                </div>
                                                                                            </template>
                                                                                        </template>
                                                                                        <template v-else>
                                                                                            <div
                                                                                                v-b-tooltip.hover
                                                                                                :title="itemData.name_short"
                                                                                                class="text-left mb-2"
                                                                                                style="cursor: pointer"
                                                                                                @click="onHandleInsertShort(itemData.name_short)"
                                                                                            >
                                                                                                {{ itemData.name_short }}
                                                                                            </div>
                                                                                        </template>
                                                                                    </td>
                                                                                    <td class="text-left colThree">
                                                                                        <div
                                                                                            class="row-data-large text-wrap"
                                                                                            v-b-tooltip.hover
                                                                                            :title="itemData.description"
                                                                                            v-html="convertNtoBr(itemData.description)"
                                                                                        ></div>
                                                                                    </td>
                                                                                </tr>
                                                                            </table>
                                                                        </b-collapse>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                        </template>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer>
                <div class="d-flex justify-content-center">
                    <div class="text-center flex-fill box__button--custom">
                        <button type="button" v-if="template.id && checkPermission('master.edit')" @click="save(1)" class="btn btn-success ml-3">
                            {{ $t('screenMaster.template.overwriteSave') }}
                        </button>
                        <button type="button" v-if="template.id && checkPermission('master.edit')" @click="save(2)" class="btn btn-primary ml-3">
                            {{ $t('btn.save') }}
                        </button>
                        <button
                            v-if="checkPermission('master.register')"
                            type="button"
                            @click="$bvModal.show('modal-othername')"
                            class="btn btn-common btn-info ml-3"
                        >
                            {{ $t('screenMaster.template.saveAs') }}
                        </button>

                        <button type="button" v-if="template.id" class="btn btn-light ml-3" @click="rollback()">
                            {{ $t('screenMaster.template.returnToPreviousState') }}
                        </button>
                        <button
                            type="button"
                            v-if="template.id && checkPermission('master.delete')"
                            class="btn btn-danger ml-3"
                            :disabled="!template.is_create"
                            @click="deleteTemplate()"
                        >
                            {{ $t('btn.delete') }}
                        </button>
                    </div>
                </div>
            </Footer>

            <b-modal no-close-on-backdrop id="modal-othername" title="条件設定" title-class="font-18" scrollable hide-footer>
                <form class="needs-validation" autocomplete="off">
                    <div class="form-group row">
                        <label class="col-sm-1" style="min-width: 100px">{{ $t('screenMaster.template.enterAliasName') }}</label>
                        <div class="col-sm-9 pl-0">
                            <div style="position: relative">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="templateDetail.name"
                                    :class="{
                                        'is-invalid': checkSecond && !templateDetail.name
                                    }"
                                />
                                <span v-if="checkSecond && !templateDetail.name" class="error">エンドクライアントを選択してください。</span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="d-flex justify-content-center">
                            <div class="text-center flex-fill">
                                <button type="button" class="btn btn-common-cancel mr-3" @click="$bvModal.hide('modal-othername')">
                                    {{ $t('btn.cancel') }}
                                </button>
                                <button type="button" @click="save(3)" class="btn btn-common btn-success">{{ $t('btn.save') }}</button>
                            </div>
                        </div>
                    </div>
                </form>
            </b-modal>
        </div>
        <div class="d-flex justify-content-center" v-else>
            <LoadingIcon />
        </div>
    </Layout>
</template>

<style lang="scss">
.mce-content-body p {
    margin: 0 !important;
}
</style>
